import { useState, useEffect, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { WelcomeScreen } from './components/animations/WelcomeScreen';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { GroupsPage } from './pages/GroupsPage';
import { ConcertsPage } from './pages/ConcertsPage';
import { NewsPage } from './pages/NewsPage';
import { MediaPage } from './pages/MediaPage';
import { SponsorsPage } from './pages/SponsorsPage';
import { ContactPage } from './pages/ContactPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { LoginPage } from './pages/LoginPage';
import { MemberDashboard } from './pages/MemberDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { ScrollToTop } from './components/utils/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import { HeaderModeProvider } from './context/HeaderModeContext';
import { ProtectedRoute } from './components/utils/ProtectedRoute';
import { WELCOME_VISITED_KEY } from './constants';

function App() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Check if user has already seen the welcome screen
    const hasVisited = localStorage.getItem(WELCOME_VISITED_KEY);
    if (hasVisited) {
      // If already visited, show content immediately
      setShowContent(true);
    }
  }, []);

  // Stable identity: WelcomeScreen keys effects on this prop, and a fresh
  // function every render would cancel its exit timers mid-transition.
  const handleWelcomeComplete = useCallback(() => {
    setShowContent(true);
  }, []);

  return (
    <AuthProvider>
      <HeaderModeProvider>
      <WelcomeScreen onComplete={handleWelcomeComplete} />
      {showContent && (
        <Layout>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/over-ons" element={<AboutPage />} />
            <Route path="/groepen" element={<GroupsPage />} />
            <Route path="/evenementen" element={<ConcertsPage />} />
            <Route path="/berichten" element={<NewsPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/member"
              element={
                <ProtectedRoute>
                  <MemberDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      )}
      </HeaderModeProvider>
    </AuthProvider>
  );
}

export default App;
